import React from "react";
import FormBuilder from "../../windows/FormBuilder";
import { translate } from "../../utils/useful";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class FormBuilderInput extends React.Component {
    state = { checked: true }
    componentWillMount() {
    }

    checkSettings(param) {
        if (this.props.settings) {
            return this.props.settings[param]
        } else {
            return false
        }
    }

    changeValue = (value) => {
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }

    render() {
        let info = this.props.header?.information
        return (
            <div className='w-100'>

                <FormBuilder ref={(el) => this.formBuilder = el} changeValue={this.changeValue} noBtn={true} initData={this.props.data} collectionName={this.props.initData?.collectionInfo?.collectionName} width={this.props.width} onSave={this.onSave} lastStage={this.props.lastStage} saveTitle={translate('ca.Next Step')} language={this.props.language} isInput={true} />

            </div>
        );
    }
}

export default FormBuilderInput;
